import axios from 'axios';
const BASE_URL = process.env.REACT_APP_API_URL;

const getRelatedTopics = async (keywords) => {
  try {
    const payload = {
      keywords: keywords,
    };
    const access_token = localStorage.getItem('access_token');
    const response = await axios.post(`${BASE_URL}current-affairs/search_rag?num_of_results=3`, payload, {
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching related topics:', error);
    throw error;
  }
};

export const getRelatedTopicsTen = async (keywords) => {
  try {
    const payload = {
      keywords: keywords,
    };
    const access_token = localStorage.getItem('access_token');
    const response = await axios.post(`${BASE_URL}current-affairs/search_rag?num_of_results=12`, payload, {
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching related topics (10):', error);
    throw error;
  }
};

const extractMarkdownTitle = (summary) => {
  const match = typeof summary === 'string' ? summary.match(/^#####\s*(.+)$/m) : null;
  return match?.[1]?.trim() || 'Current Affairs Summary';
};

const extractKeyTakeaways = (summary) => {
  if (!summary || typeof summary !== 'string') {
    return [];
  }

  const sectionMatch = summary.match(
    /#####\s*Key Takeaways\s*\n([\s\S]*?)(?=\n#####|$)/i,
  );
  if (!sectionMatch?.[1]) {
    return [];
  }

  return sectionMatch[1]
    .split(/\r?\n/)
    .map((line) => line.replace(/^[-*•]\s*/, '').replace(/\*\*/g, '').trim())
    .filter(Boolean);
};

/** Normalize consolidated_summary API payload for existing UI consumers. */
export const normalizeConsolidatedSummary = (data) => {
  if (!data?.summary) {
    return {
      related_summaries: [],
      summary: '',
      article_count: 0,
      date_range: '',
      articles_used: [],
    };
  }

  const articlesUsed = data.articles_used || [];
  const title = extractMarkdownTitle(data.summary);
  const bullet_points = extractKeyTakeaways(data.summary);
  const endDate =
    data.date_range?.split(/\s+to\s+/i)?.[1]?.trim() ||
    articlesUsed[0]?.ca_created_date ||
    null;

  return {
    ...data,
    related_summaries: [
      {
        id: articlesUsed[0]?.id,
        topic: title,
        title,
        content: data.summary,
        summary: data.summary,
        bullet_points,
        ca_created_date: endDate,
        date_range: data.date_range,
        article_count: data.article_count,
        articles_used: articlesUsed,
        isConsolidated: true,
      },
    ],
  };
};

export const getRelatedSummaries = async (keywords) => {
  try {
    const payload = { keywords };
    const access_token = localStorage.getItem('access_token');
    const response = await axios.post(
      `${BASE_URL}current-affairs/consolidated_summary_db?num_of_results=5`,
      payload,
      {
        headers: {
          'Authorization': `Bearer ${access_token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return normalizeConsolidatedSummary(response.data);
  } catch (error) {
    console.error('Error fetching related summaries:', error);
    throw error;
  }
};

export default getRelatedTopics;
